module.exports = __webpack_public_path__ + "static/playroom2-b9c54f23860cb3d1b280d47858352d85.png";